import type { FreeBusyStatus } from 'owa-graph-schema';
import { showAsFree } from 'owa-locstrings/lib/strings/showasfree.locstring.json';
import { unknownFreeBusy } from 'owa-locstrings/lib/strings/unknownfreebusy.locstring.json';
import { showAsWorkingElsewhere } from 'owa-locstrings/lib/strings/showasworkingelsewhere.locstring.json';
import { showAsAway } from 'owa-locstrings/lib/strings/showasaway.locstring.json';
import { showAsTentative } from 'owa-locstrings/lib/strings/showastentative.locstring.json';
import { showAsBusy } from 'owa-locstrings/lib/strings/showasbusy.locstring.json';
import loc from 'owa-localize';

export default function convertFreeBusyStatusToString(status: FreeBusyStatus): string {
    switch (status) {
        case 'Unknown':
            return loc(unknownFreeBusy);
        case 'Free':
            return loc(showAsFree);
        case 'Tentative':
            return loc(showAsTentative);
        case 'Busy':
            return loc(showAsBusy);
        case 'Oof':
            return loc(showAsAway);
        case 'WorkingElsewhere':
            return loc(showAsWorkingElsewhere);
        default:
            throw new Error('Unknown free-busy status');
    }
}
